var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEspiral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "23px",
    viewBox: "0 0 88 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "espiral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.0680743%",
    y1: "35.882568%",
    x2: "45.5393836%",
    y2: "83.7889099%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D7D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.0737691%",
    y1: "35.882568%",
    x2: "45.5374398%",
    y2: "83.7889099%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D7D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.3840244%",
    y1: "-12.4157308%",
    x2: "5.93589467%",
    y2: "70.4745245%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838387",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.3734802%",
    y1: "-12.4157308%",
    x2: "5.99131164%",
    y2: "70.4745245%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838387",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.3683313%",
    y1: "-12.4157308%",
    x2: "6.01837309%",
    y2: "70.4745245%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838387",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desarrollo-Juego",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-616, -419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(361.0652, 382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "espiral",
    transform: "translate(255.1089, 37.6826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(44.5202, 0.1303)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6436308,21.5808157 C10.1243025,21.5771971 7.94112549,20.1551227 6.84230795,18.0708608 C6.63989419,17.6909173 6.47724027,17.2856441 6.35434621,16.8658969 L4.81817036,13.0845539 L2.39643432,7.12848618 L2.35305994,7.14657873 L0,1.23031466 C1.08074489,0.455953488 2.40366338,-0.00359729908 3.83863235,0 C6.49531293,0.00363972119 8.77969678,1.58854716 9.81345276,3.86097152 L9.81345276,3.86097152 L11.794216,8.47457195 L16.5906991,20.2672965 C15.4918816,21.0886983 14.1255887,21.5735786 12.6508599,21.5735786 L12.6436308,21.5808157 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5391758,21.6097637 C28.0198474,21.6061452 25.8366705,20.1840707 24.7378529,18.0998089 C24.5354392,17.7198653 24.3727853,17.3145922 24.2498912,16.894845 L22.7137153,13.1135019 L20.2919793,7.15743426 L20.2486049,7.17552681 L17.895545,1.25926274 C18.9762899,0.484901569 20.2992084,0.025350782 21.7341773,0.0289480811 C24.3908579,0.0325878023 26.6752418,1.61749524 27.7089977,3.88991961 L27.7559866,3.86820854 L29.6933755,8.50352003 L34.4898586,20.2962446 C33.3910411,21.1176464 32.0247482,21.6025267 30.5500194,21.6025267 L30.5391758,21.6097637 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6691158,0.0325808775 C19.1497874,0.0289692921 16.9629959,1.44380675 15.8533347,3.52083157 C15.650921,3.90077514 15.4846525,4.30242976 15.3581439,4.72217694 L13.80751,8.49990152 L11.3207124,14.4270211 L11.3207124,14.4270211 L8.94596522,20.3324297 C10.0230956,21.1104093 11.3460141,21.5735786 12.7773685,21.5772034 C15.4340491,21.5808157 17.725662,20.0067637 18.766647,17.7343394 L18.813636,17.7560504 L20.7654829,13.127976 L25.6053405,1.34972549 C24.5101374,0.524705181 23.1474591,0.0325808775 21.6691158,0.0325808775 L21.6691158,0.0325808775 Z",
    id: "Path",
    fill: "#D81925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.369476,0.0651474687 C36.8501477,0.0615358833 34.6633562,1.47637335 33.553695,3.55339816 C33.3512813,3.93334173 33.1850128,4.33499635 33.0585042,4.75474353 L31.5078702,8.53246811 L29.064447,14.4812988 L29.0210726,14.4632062 L26.6463255,20.3686148 C27.7234559,21.1465944 29.0463744,21.6097637 30.4777288,21.6133885 C33.1344094,21.6170008 35.4260223,20.0429488 36.4670073,17.7705245 L36.5139962,17.7922355 L38.4658432,13.1641611 L43.3057007,1.38591059 C42.2104977,0.560890282 40.8478194,0.0687729036 39.369476,0.0687729036 L39.369476,0.0651474687 Z",
    id: "Path",
    fill: "#D81925"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0.69938151,
    points: "70.1219092 1.48722888 67.2302841 13.2546238 66.2615897 10.8772627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6474286,21.5808157 C19.1281002,21.5771971 16.9449232,20.1551227 15.8461057,18.0708608 C15.6436919,17.6909173 15.481038,17.2856441 15.3581439,16.8658969 L13.8219681,13.0845539 L11.400232,7.12848618 L11.3568577,7.14657873 L9.00379772,1.23031466 C10.0845426,0.455953488 11.4074611,-0.00359729908 12.8424301,0 C15.4991107,0.00363972119 17.7834945,1.58854716 18.8172505,3.86097152 L18.8642394,3.83926046 L20.8016282,8.47457195 L25.5981114,20.2672965 C24.4992938,21.0886983 23.133001,21.5735786 21.6582722,21.5735786 L21.6474286,21.5808157 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3441743,21.6097637 C36.8248459,21.6061452 34.641669,20.1840707 33.5428514,18.0998089 C33.3404377,17.7198653 33.1777837,17.3145922 33.0548897,16.894845 L31.5187138,13.1135019 L29.0969778,7.15743426 L29.0536034,7.17552681 L26.7005435,1.25926274 C27.7812884,0.484901569 29.1042069,0.025350782 30.5391758,0.0289480811 C33.1958564,0.0325878023 35.4802403,1.61749524 36.5139962,3.88991961 L36.5609851,3.86820854 L38.498374,8.50352003 L43.2948571,20.2962446 C42.1960396,21.1176464 40.8297467,21.6025267 39.3550179,21.6025267 L39.3441743,21.6097637 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7773685,0.00363279645 C10.2580401,2.12110592e-05 8.07124862,1.41485867 6.96158748,3.49188349 C6.75917372,3.87182705 6.59290528,4.27348168 6.46639668,4.69322886 L4.91576271,8.47095344 L2.47233948,14.4197841 L2.4289651,14.4016915 L0.054217971,20.3071001 C1.13134833,21.0850798 2.45426682,21.5482491 3.88562126,21.5518738 C6.54230184,21.5554861 8.83391475,19.9814342 9.87489979,17.7090098 L9.9218887,17.7307209 L11.8737357,13.1026464 L16.7135932,1.32439592 C15.6183902,0.49937561 14.2557119,0.00725823133 12.7773685,0.00725823133 L12.7773685,0.00363279645 Z",
    id: "Path",
    fill: "#D81925",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4741143,0.0361993877 C27.9547859,0.0325878023 25.7679944,1.44742526 24.6583332,3.52445008 C24.4559195,3.90439365 24.289651,4.30604827 24.1631424,4.72579545 L22.6125085,8.50352003 L20.1690852,14.4523507 L20.1257109,14.4342581 L17.7509637,20.3396667 C18.8280941,21.1176464 20.1510126,21.5808157 21.582367,21.5844404 C24.2390476,21.5880527 26.5306605,20.0140008 27.5716455,17.7415764 L27.6186345,17.7632875 L29.5704814,13.135213 L34.410339,1.35696251 C33.3151359,0.531942201 31.9524576,0.0398248225 30.4741143,0.0398248225 L30.4741143,0.0361993877 Z",
    id: "Path",
    fill: "#D81925",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.279296,0.0651474687 C45.7599676,0.0615358833 43.5731761,1.47637335 42.4635149,3.55339816 C42.2611012,3.93334173 42.0948327,4.33499635 41.9683241,4.75474353 L40.4176901,8.53246811 L37.9742669,14.4812988 L37.9308925,14.4632062 L35.5561454,20.3686148 C36.6332758,21.1465944 37.9561943,21.6097637 39.3875487,21.6133885 C42.0442293,21.6170008 44.3358422,20.0429488 45.3768272,17.7705245 L45.4238161,17.7922355 L47.3756631,13.1641611 L52.2155206,1.38591059 C51.1203176,0.560890282 49.7576393,0.0687729036 48.279296,0.0687729036 L48.279296,0.0651474687 Z",
    id: "Path",
    fill: "#D81925",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1350811,0.162847242 C63.6157527,0.159235657 61.4289612,1.57407312 60.3193001,3.65109794 C60.1168863,4.0310415 59.9506179,4.43269613 59.8241093,4.8524433 L58.2734753,8.63016788 L55.7866777,14.5572875 L55.7866777,14.5572875 L53.4119305,20.462696 C54.4890609,21.2406757 55.8119794,21.703845 57.2433338,21.7074697 C59.9000144,21.711082 62.1916273,20.1370301 63.2326124,17.8646057 L63.2796013,17.8863168 L65.2314482,13.2582423 L70.0713058,1.47999186 C68.9761028,0.654971545 67.6134244,0.162847242 66.1350811,0.162847242 L66.1350811,0.162847242 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8354414,0.195413834 C81.316113,0.191802248 79.1293215,1.60663971 78.0196603,3.68366453 C77.8172466,4.06360809 77.6509781,4.46526272 77.5244695,4.88500989 L75.9738356,8.66273447 L73.5304123,14.6115651 L73.487038,14.5934726 L71.1122908,20.4988811 C72.1894212,21.2768608 73.5123397,21.7400301 74.9436941,21.7436548 C77.6003747,21.7472671 79.8919876,20.1732152 80.9329726,17.9007908 L80.9799616,17.9225019 L82.9318085,13.2944274 L87.7716661,1.51617696 C86.676463,0.691156647 85.3137847,0.199039268 83.8354414,0.199039268 L83.8354414,0.195413834 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7231505,0.00363279645 C10.2038222,2.12110592e-05 8.01703065,1.41485867 6.90736951,3.49188349 C6.70495575,3.87182705 6.53868731,4.27348168 6.41217871,4.69322886 L4.86154474,8.47095344 L2.41812151,14.4197841 L2.37474713,14.4016915 L0,20.3071001 C1.07713036,21.0850798 2.40004885,21.5482491 3.83140329,21.5518738 C6.48808387,21.5554861 8.77969678,19.9814342 9.82068182,17.7090098 L9.86767073,17.7307209 L11.8195177,13.1026464 L16.6593752,1.32439592 C15.5641722,0.49937561 14.2014939,0.00725823133 12.7231505,0.00725823133 L12.7231505,0.00363279645 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4235108,0.0361993877 C27.9041824,0.0325878023 25.7173909,1.44742526 24.6077298,3.52445008 C24.405316,3.90439365 24.2390476,4.30604827 24.112539,4.72579545 L22.561905,8.50352003 L20.1184818,14.4523507 L20.0751074,14.4342581 L17.7003603,20.3396667 C18.7774906,21.1176464 20.1004091,21.5808157 21.5317636,21.5844404 C24.1884441,21.5880527 26.4800571,20.0140008 27.5210421,17.7415764 L27.568031,17.7632875 L29.519878,13.135213 L34.3597355,1.35696251 C33.2645325,0.531942201 31.9018542,0.0398248225 30.4235108,0.0398248225 L30.4235108,0.0361993877 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2286925,0.0651474687 C45.7093641,0.0615358833 43.5225726,1.47637335 42.4129115,3.55339816 C42.2104977,3.93334173 42.0442293,4.33499635 41.9177207,4.75474353 L40.3670867,8.53246811 L37.9236635,14.4812988 L37.8802891,14.4632062 L35.505542,20.3686148 C36.5826723,21.1465944 37.9055908,21.6097637 39.3369453,21.6133885 C41.9936258,21.6170008 44.2852388,20.0429488 45.3262238,17.7705245 L45.3732127,17.7922355 L47.3250597,13.1641611 L52.1649172,1.38591059 C51.0697142,0.560890282 49.7070359,0.0687729036 48.2286925,0.0687729036 L48.2286925,0.0651474687 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0.69938151,
    points: "16.7135932 1.32077741 13.8183536 13.0881724 12.8532737 10.7108112"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.69938151,
    points: "34.410339 1.353344 31.5187138 13.1171204 30.5536339 10.7433778"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    opacity: 0.69938151,
    points: "52.2082916 1.40400314 49.3166665 13.1713981 48.3515866 10.7940369"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspiral);
export default __webpack_public_path__ + "static/media/espiral.d974c0747cd352b75bfeeb185b13cee3.svg";
export { ForwardRef as ReactComponent };